import CsvFile from "./csv-file";
import LoaderIcon from "./loader-icon";

export default {
  CsvFile,
  LoaderIcon
};



// WEBPACK FOOTER //
// ./src/assets/icon/index.js